import { render, staticRenderFns } from "./view-fetch.vue?vue&type=template&id=4d5608aa"
import script from "./view-fetch.vue?vue&type=script&lang=js"
export * from "./view-fetch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports